import { type FunctionComponent } from 'react';

export type ColorTextProps = {
	colorName: string;
	mobileOnly: boolean;
	className?: string;
};

export const ColorText: FunctionComponent<ColorTextProps> = ({ colorName, mobileOnly, className }) => {
	return (
		<div className={className}>
			<div className={`tl theme-grey f7 ${mobileOnly ? 'dn-ns' : ''}`}>Color: {colorName}</div>
		</div>
	);
};
